module.exports = __webpack_public_path__ + "img/imgZXGH(23).244b49bb.png";